import moment from "moment/moment";
import React from "react";

const TransferItem = ({
  val,
  setShow,
  setModalData,
  setDetailType,
  setDeleting,
}) => {
  return (
    <>
      <div className="booking-main-wrap">
        <div className="booking-wrap">
          <div>
            <div className="booking-icon-wrap">
              <img src="assets/images/car-icon.svg" alt="err" />
            </div>
          </div>
          <div className="booking-lists">
            <h5 className="b-b-20">
              {val?.searchPayload?.Transfer?.JourneyDetail?.ItemName}
            </h5>
            <h6 className="b-medium-16">
              {moment(
                val?.searchPayload?.Transfer?.JourneyDetail?.PickupDate
              ).format("MMMM Do YYYY")}
            </h6>
          </div>
        </div>
        <div className="buttons-wrap">
          <span
            className="cancel-btn"
            onClick={() => {
              setShow(true);
              setModalData(val.ConfirmationNo);
              setDetailType("transfer");
              setDeleting("");
            }}
          >
            detail
          </span>

          <span
            className="cancel-btn"
            onClick={() => {
              setShow(true);
              setModalData(val.ConfirmationNo);
              setDetailType("");
              setDeleting("transfer");
            }}
          >
            Cancel Booking
          </span>
        </div>
      </div>
    </>
  );
};

export default TransferItem;
